var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManHairstyle3D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "type4_x5F_hair:"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x33_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#87634D",
    d: "M253.7,176.4c2.5-10.4,9.1-20.4,12.1-30.8c2.9-9.9,0.7-20.6,9.5-31.9c11.6-14.8,43-19.9,66.7-22.4 c-6.4,0.1-12.7,0.2-18.9,0.5c-16.5,0.9-32.7,2-46.5,11c-15.9,10.4-17.5,20.4-21.4,37c-3.6,15.5-11.2,33.1-10.7,49 c0.5,15.8,6.8,40,11.7,46.2c0.4,0.5,0.8,1,1.2,1.5C259,215.6,248.8,196.9,253.7,176.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#654023",
    d: "M453,129.2c-2.9-16-5.5-26.6-22.7-33c-16-6-36.4-5.8-53.2-5.2c-11.3,0.3-23.3,0.2-35.1,0.3 c-23.7,2.5-55.2,7.6-66.7,22.4c-8.8,11.3-6.7,22-9.5,31.9c-3,10.4-9.6,20.4-12.1,30.8c-4.9,20.6,5.3,39.3,3.9,60.1 c3.7,4.7,6,10.6,7.6,16.1c1.9-9.4-4.2-23.1,1.3-44.1c1.8-7,7.7-14.1,12.3-19.9c5.8-7.3,5.6-10.6,6.1-19.9 c1.2-19.9,14.5-20.7,31.8-18.1c16.6,2.5,32,6.4,50,4.2c16.4-2,32.3-9.5,47.3-7.6c20.9,2.6,16.3,21.5,21.1,37.5 c3.9,13.2,12.6,17.3,15.2,39.9c1.6,13.7,2.9,24.9,2.4,41.4c17.1-38.1,9.1-60.1,11.5-93.6C465.4,156.2,456.2,147.1,453,129.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManHairstyle3D);
export default __webpack_public_path__ + "static/media/man_hairstyle_3d.b75d608c9418bf9db6fb98479bd77cb0.svg";
export { ForwardRef as ReactComponent };